import classNames from "classnames";

const Divider = ({ className }: { className?: string }) => (
  <div className={classNames(className, "border-b border-b-sand-700 ")} />
);
export default Divider;
